import { Primitive } from '../entities';

export const areArraysOfPrimitivesEqual = <T extends Primitive>(arr1: Array<T>, arr2: Array<T>) => {
  if (arr1.length !== arr2.length) return false;
  return arr1.every((id, index) => id === arr2[index]);
};
